import React from 'react';
import Button from 'react-bootstrap/Button';

type MergeButtonProps = {
  canExecute: boolean;
  executing: boolean;
  loading: boolean;
  hasEligibleInmates: boolean;
  onClick: () => void;
};

const MergeButton: React.FC<MergeButtonProps> = ({
  canExecute,
  executing,
  loading,
  hasEligibleInmates,
  onClick
}) => {
  return (
    <div className="mb-3">
      <Button
        variant="primary"
        onClick={onClick}
        disabled={!canExecute || executing || loading}>
        {executing ? (
          <>
            <i className="fas fa-spin fa-spinner"></i> Merging...
          </>
        ) : (
          <>
            <i className="fas fa-code-branch"></i> Merge
          </>
        )}
      </Button>
      {!hasEligibleInmates && !executing && !loading && (
        <div className="text-muted" style={{ marginTop: '0.5rem' }}>
          No inmates are eligible to merge.
        </div>
      )}
    </div>
  );
};

export default MergeButton;
